;(function($) {

    function showDetail(node) {
        var img = $(node).data('image');
        var width = $(node).data('width');
        var height = $(node).data('height');
        var target = $(node).data('image-target');
        var targetNodes = $(target);

        targetNodes.each(function(idx, targetNode){
            if($(targetNode).prop("tagName") === 'IMG'){
                img && target && $(targetNode).attr('src', img);
            } else {
                img && target && $(targetNode).css('background-image', 'url(' + img + ')');
            }
            $(targetNode).data('image', img).data('width', width).data('height', height);
            $(targetNode).parent().removeClass('shows-video').addClass('shows-image');
            resizeTarget(targetNode);
        });
    }

    function resizeTarget(node) {
        var width = $(node).data('width');
        var height = $(node).data('height');
        if(width && height){
            $(node).parent().height($(node).parent().width() * 5 / 6);
        } else {
            $(node).parent().css('height', 'auto');
        }
    }

    function showVideo(node) {
        const player = $('#' + $(node).data('identifier'));
        const target = $(node).data('video-target');
        const galleryTarget = $(node).data('gallery-target');
        const img = $(node).data('image');

        if(player.length && target.length){
            $(target).empty();
            $(target).append(player.clone().html());
            $(target).parent().addClass('shows-video').removeClass('shows-image');
            $(target).data('width', null).data('height', null);

            // Show the thumbnail image in the slider
            if (img) {
                $(galleryTarget).css('background-image', 'url(' + img + ')');
                $(galleryTarget).closest('.main-image').addClass('shows-video').removeClass('shows-image');
            }

            window.initOverlayLazyEmbed('.article-content-layer .embed-responsive > iframe[data-lazyembed-overlay="video"]')

            resizeTarget(target);
        }
    }

    function initMobileDetail(node) {
        var img = $(node).data('image');
        var width = $(node).data('width');
        var target = $(node).data('image-target');
        var targetNodes = $(target);

        targetNodes.each(function(idx, targetNode){
            $(targetNode).parents('.product-gallery').find('.article-openseadragon').addClass('openseadragon').data('image', img).data('width', width)
        });
    }

    function initArticleGallery(node) {
        var targets = [];
        $('[data-image][data-image-target]', node).each(function(idx,node){
            var target = $(node).data('image-target');
            if(targets.indexOf(target) < 0){
                targets.push(target);
                showDetail(node);
                initMobileDetail(node);
            }
        });

        $(node).on('click', '[data-image][data-image-target]', function (e) {
            showDetail(e.currentTarget);
        });

        $(node).on('click', '[data-identifier][data-video-target]', function (e) {
            showVideo(e.currentTarget);
        });

        $(node).on('mouseover', '.article-gallery-button', (e) => {
            const target = e.target.closest('.article-gallery-button');

            $(target).find('.article-gallery-button--rest').attr('aria-hidden', 'true');
            $(target).find('.article-gallery-button--other').attr('aria-hidden', 'false');
        });

        $(node).on('mouseleave', '.article-gallery-button', (e) => {
            const target = e.target.closest('.article-gallery-button');

            $(target).find('.article-gallery-button--rest').attr('aria-hidden', 'false');
            $(target).find('.article-gallery-button--other').attr('aria-hidden', 'true');
        });
    }

    $.fn.articleGallery = function(cmd) {
        switch (cmd) {
            case 'resizeTarget':
                $(this).each(function (i,n) {
                    resizeTarget(n);
                });
                break;
            default:
                $(this).each(function (i,n) {
                    initArticleGallery(n);
                });
        }
        return this;
    }
})(jQuery);
